function getPopupContainer(triggerNode?: HTMLElement): HTMLElement {
  // if (triggerNode) return triggerNode;
  // const watermarkNode = document.getElementsByClassName('watermark');
  // console.log('watermarkNode', watermarkNode, watermarkNode.length);
  return document.body;
}

export default getPopupContainer;
